module.exports = __webpack_public_path__ + "img/invoice-logo.f17c8174.png";